(function (app) {
  $(document).ready(function () {

    app.InsightText = function () {

      var _this = this;

      var nameSpace = 'InsightText',
        context = '.page__insight-text--container'
        ;

      /**
       *
       * @param url
       * @param callback
       * @returns {*}
       */
      _this.get = function (url, callback) {
        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            callback(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(url);
        return query.promise();
      };


      _this.getUrl = function (url, category) {
        if (_.isUndefined(category)) {
          return url;
        } else {
          if (url.indexOf('?') >= 0) {
            return url + '&' + 'category=' + category;
          } else {
            return url + '?' + 'category=' + category;
          }

        }

      };

      /**
       * Get Text Sentiment
       */
      _this.getTextTop3 = function (category) {
        var $sentimentDataBody = $('.text-sentiment__body', $(context));
        $sentimentDataBody.html('');
        $sentimentDataBody.addClass('m-progress');

        var $emotionalDataBody = $('.text-emotional__body', $(context));
        $emotionalDataBody.html('');
        $emotionalDataBody.addClass('m-progress');

        _this.get(_this.getUrl('/api/insight/text-top-3', category), function (response) {
          $sentimentDataBody.removeClass('m-progress');
          $emotionalDataBody.removeClass('m-progress');
          var dataRow = _.template(app.templates["Insight__text____sentiment"]);
          var $dataRow = $(
            dataRow(
              $.extend(response.sentiment, {})
            )
          );
          $dataRow.appendTo($sentimentDataBody);

          $dataRow = $(
            dataRow(
              $.extend(response.emotional, {})
            )
          );
          $dataRow.appendTo($emotionalDataBody);

          if (_.isEmpty(response.sentiment['yours'])) {
            dataRow = _.template(app.templates["Insight__text____no-records"]);
            $dataRow = $(
              dataRow(
              )
            );

            $dataRow.appendTo($sentimentDataBody.find('.yours-data'));
          }

          if (_.isEmpty(response.emotional['yours'])) {
            dataRow = _.template(app.templates["Insight__text____no-records"]);
            $dataRow = $(
              dataRow(
              )
            );

            $dataRow.appendTo($emotionalDataBody.find('.yours-data'));
          }
        })
      };

      /**
       *
       */
      _this.getTextEngagementHeadlines = function (category) {
        var $dataBodyYours = $('.text-engagement-headlines-yours__body', $(context));
        var $dataBodyall = $('.text-engagement-headlines-all-users__body', $(context));
        $dataBodyYours.html('');
        $dataBodyall.html('');
        $dataBodyYours.addClass('m-progress');
        $dataBodyall.addClass('m-progress');
        _this.get(_this.getUrl('/api/insight/text-engagement?type=Headline', category), function (response) {
          $dataBodyYours.removeClass('m-progress');
          $dataBodyall.removeClass('m-progress');

          var dataRow = _.template(app.templates["Insight__text____engagement"]);
          var $dataRow = $(
            dataRow(
              {'rows': response['yours'], 'olClass': ''}
            )
          );

          $dataRow.appendTo($dataBodyYours);

          $dataRow = $(
            dataRow(
              {'rows': response['all'], 'olClass': 'light-blue'}
            )
          );
          $dataRow.appendTo($dataBodyall);

          if (_.isEmpty(response['yours'])) {
            dataRow = _.template(app.templates["Insight__text____no-records"]);
            $dataRow = $(
              dataRow(
              )
            );
            $dataRow.appendTo($dataBodyYours);
          }

          if (_.isEmpty(response['all'])) {
            $dataBodyall.closest('.row').hide();
          } else {
            $dataBodyall.closest('.row').show();
          }

        })
      };

      /**
       *
       */
      _this.getTextEngagementBody = function (category) {
        var $dataBodyYours = $('.text-engagement-body-yours__body', $(context));
        var $dataBodyall = $('.text-engagement-body-all-users__body', $(context));
        $dataBodyYours.html('');
        $dataBodyall.html('');
        $dataBodyYours.addClass('m-progress');
        $dataBodyall.addClass('m-progress');
        _this.get(_this.getUrl('/api/insight/text-engagement?type=Body', category), function (response) {
          $dataBodyYours.removeClass('m-progress');
          $dataBodyall.removeClass('m-progress');

          var dataRow = _.template(app.templates["Insight__text____engagement"]);
          var $dataRow = $(
            dataRow(
              {'rows': response['yours'], 'olClass': ''}
            )
          );

          $dataRow.appendTo($dataBodyYours);

          $dataRow = $(
            dataRow(
              {'rows': response['all'], 'olClass': 'light-blue'}
            )
          );
          $dataRow.appendTo($dataBodyall);

          if (_.isEmpty(response['yours'])) {
            dataRow = _.template(app.templates["Insight__text____no-records"]);
            $dataRow = $(
              dataRow(
              )
            );
            $dataRow.appendTo($dataBodyYours);
          }

          if (_.isEmpty(response['all'])) {
            $dataBodyall.closest('.row').hide();
          } else {
            $dataBodyall.closest('.row').show();
          }

        })
      };

      /**
       *
       */
      _this.getTextEngagementCta = function (category) {
        var $dataBodyYours = $('.text-engagement-cta-yours__body', $(context));
        var $dataBodyall = $('.text-engagement-cta-all-users__body', $(context));
        $dataBodyYours.html('');
        $dataBodyall.html('');
        $dataBodyYours.addClass('m-progress');
        $dataBodyall.addClass('m-progress');
        _this.get(_this.getUrl('/api/insight/text-engagement?type=Call to Action', category), function (response) {
          $dataBodyYours.removeClass('m-progress');
          $dataBodyall.removeClass('m-progress');

          var dataRow = _.template(app.templates["Insight__text____engagement"]);
          var $dataRow = $(
            dataRow(
              {'rows': response['yours'], 'olClass': ''}
            )
          );

          $dataRow.appendTo($dataBodyYours);

          $dataRow = $(
            dataRow(
              {'rows': response['all'], 'olClass': 'light-blue'}
            )
          );
          $dataRow.appendTo($dataBodyall);

          if (_.isEmpty(response['yours'])) {
            dataRow = _.template(app.templates["Insight__text____no-records"]);
            $dataRow = $(
              dataRow(
              )
            );
            $dataRow.appendTo($dataBodyYours);
          }

          if (_.isEmpty(response['all'])) {
            $dataBodyall.closest('.row').hide();
          } else {
            $dataBodyall.closest('.row').show();
          }

        })
      };

      _this.lastUpdatedToUserTimezone = function () {
        var $lastUpdated = $('[data-last-updated]');
        var lastUpdated = $lastUpdated.attr('data-last-updated');
        lastUpdated = app.utcToUserTimezone(lastUpdated);
        $lastUpdated.text(lastUpdated);
      };

      return {
        init: function () {
          _this.lastUpdatedToUserTimezone();

          _this.getTextTop3();

          _this.getTextEngagementHeadlines();
          _this.getTextEngagementBody();
          _this.getTextEngagementCta();

          $(document).off('click.actions__' + nameSpace).on('click.actions__' + nameSpace, context + ' [data-action]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $button = $(this);
            var action = $button.attr('data-action');
            var $li = $button.closest('li');
            $('[data-modal-insight-text]').remove();

            var dataRow = _.template(app.templates["Insight__text____modal"]);
            var $dataRow = $(
              dataRow(
                {'modalTitle': '#' + ($li.index() + 1), 'modalBody': $li.find('span').html()}
              )
            );

            $dataRow.appendTo($('body'));
            $('[data-modal-insight-text]').modal('show');

          });

          $(document).off('change.search__' + nameSpace).on('change.search__' + nameSpace, context + ' select[name=category]', function (e) {

            var category = $(this).val();
            _this.getTextTop3(category);

            _this.getTextEngagementHeadlines(category);
            _this.getTextEngagementBody(category);
            _this.getTextEngagementCta(category);

          });

        }
      };
    };
  });
})(PreBuilt);

